<template>
  <CreateItem
    :status="status"
    model="body-color"
    :latest="latest"
  >
    <FormBodyColorCreate v-if="status !== 'loading'" />
  </CreateItem>
</template>

<script>
import { mapState } from 'vuex';
import FormBodyColorCreate from '../../components/FormBodyColorCreate/FormBodyColorCreate';
import CreateItem from '../../layouts/CreateItem/CreateItem';

export default {
  name: 'BodyColorCreate',
  components: {
    FormBodyColorCreate,
    CreateItem
  },
  mounted() {
    this.$store.dispatch('bodyColor/RESET_STATUS');
  },
  computed: {
    ...mapState({
      status: state => state.bodyColor.status
    }),
    latest() {
      const bodyColors = this.$store.getters['bodyColor/getAll'];

      return bodyColors[bodyColors.length - 1];
    }
  }
};
</script>
